function trackZohoPageSenseEvent(name) {
  window.pagesense = window.pagesense || [];
  window.pagesense.push(['trackEvent', name]);
}

export default trackZohoPageSenseEvent;
